import {Component, Input, Output, EventEmitter} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'quiz-type-component',
    templateUrl: 'quiz-type.component.html'
})
export class QuizTypeComponent {
    quizTypeControl = new FormControl();
    options = [
        {
            title: 'Standard',
            type: 'normal'
        },
        {
            title: 'Personality',
            type: 'personality'
        }
    ];

    // using getters and settings for default values
    private _canEdit = false;
    private _listOnly = false;
    private _quizType = 'normal';

    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('listOnly')
    set listOnly(listOnly) {
        this._listOnly = listOnly;
    }
    get listOnly() {
        return this._listOnly;
    }
    @Input('quizType')
    set quizType(quizType) {
        this._quizType = quizType;
    }
    get quizType() {
        return this._quizType;
    }
    @Output() quizTypeChange = new EventEmitter();

    constructor() {
        this.quizTypeControl.valueChanges.subscribe(option => {
            if( option ) {
                this.quizType = option.type;
                this.quizTypeChange.emit(this.quizType);
            }
        });
    }
    ngAfterViewInit() {
        const options = this.options;
        let hasValue = false;
        for(var i = 0; i < options.length; i++) {
            if( this.quizType == options[i].type ) {
                this.quizTypeControl.setValue(this.options[i]);
                hasValue = true;
            }
        }
        if( !hasValue ) {
            this.quizTypeControl.setValue(this.options[0]);
        }
    }
}